import { useContext, useEffect, useRef } from "react";
import styles from "./Figure.module.scss";
import PathContext from "../../context/path";
import clsx from 'clsx';

const Figure = (props) => {
  const { color, form, bg, opacity, rotate, styleFigure, className } = props;
  const path = useContext(PathContext);
  const refbg = useRef(null);
  const refWrap = useRef(null);
  let bgImg = null;
  let classWrap = `${styles.wrap}`;
  useEffect(() => {
    if (opacity !== undefined && opacity <= 1 && opacity >= 0) {
      refbg.current.style.opacity = opacity;
    }
    
  }, [color, opacity]);
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    classWrap += ` ${styles[`wrap_${color}`]}`;
  }
  if (form !== undefined && styles[`wrap_${form}`] !== undefined) {
    classWrap += ` ${styles[`wrap_${form}`]}`;
  }
  if (rotate !== undefined) {
    classWrap += ` ${styles.wrap_rotate}`;
  }
  if (className !== undefined) {
    classWrap += ` ${className}`;
  }
  if (bg !== undefined) {
    bgImg = <img src={`${path}/img/${bg}`} alt="" />;
  }
  return (
    <>
      <div className={clsx(classWrap, className)} style={styleFigure} ref={refWrap}>
        <div className={styles.bg} ref={refbg}>
          {bgImg}
        </div>
        {props.children}

      </div>
    </>
  );

}

export default Figure;
